import { render, staticRenderFns } from "./TokenConfirmationCheck.vue?vue&type=template&id=23a4b820&lang=pug"
import script from "./TokenConfirmationCheck.vue?vue&type=script&lang=js"
export * from "./TokenConfirmationCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports